export function updateObjectAtPosition(arr, index, key, newValue, setRoleData) {
  if (index >= 0 && index < arr.length && arr[index].hasOwnProperty(key)) {
    const updatedArr = [...arr];
    updatedArr[index] = { ...updatedArr[index], [key]: newValue };
    setRoleData(updatedArr);
  } else {
    console.log("Invalid index or key");
  }
}
